import { ChartContextProvider } from 'contexts/CategoryChartContext';
import { FilterContextProvider } from 'contexts/FilterContext';
import React from 'react';
/**
 * withCategoryManagementProviders HOC Component
 * @param {JSX} WrappedComponent - Accepts a component and gives a Wrapped componets with Context Providers
 */

// Higher Order Component (HOC) that wraps a component with multiple providers

const withCategoryWidgetsProviders = WrappedComponent => {
	// Return a new component with added context providers
	return function CategoryWidgetsWrapper(props) {
		return (
			<>
				<FilterContextProvider>
					<ChartContextProvider>
						<WrappedComponent {...props} />
					</ChartContextProvider>
				</FilterContextProvider>
			</>
		);
	};
};
export default withCategoryWidgetsProviders;
